var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-column h-100"},[_c('div',[_c('SystemBar')],1),_c('div',{staticClass:"flex-fill overflow-auto"},[_c('Info'),(!_vm.formIsMain.isActive && _vm.mainPath !== _vm.$route.path)?_c('ViewHeader'):_vm._e(),_c('Questionnaire')],1),_c('div',[_c('OcularSign')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }